import { memo } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { areEqual } from 'react-window';
import styled from 'styled-components';
import { Stop } from '../../../../domain/stop/Stop';
import { StopChip } from './StopChip';

export const VirtualizedRowContainer = styled.div`
  display: flex;
  user-select: none;
`;

type VirtualizedStopRowProps = {
  data: Stop[];
  index: number;
  style: any;
};

export const VirtualizedStopRow = memo(({ data: stops, index, style }: VirtualizedStopRowProps) => {
  const stop = stops[index];
  return (
    <Draggable draggableId={stop.id} index={index} key={stop.id}>
      {(provided, snapshot) => (
        <VirtualizedRowContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...style, ...provided.draggableProps.style }}
        >
          <StopChip stop={stop} isDragging={snapshot.isDragging} />
        </VirtualizedRowContainer>
      )}
    </Draggable>
  );
}, areEqual);
